module.exports = __webpack_public_path__ + "static/media/71ODe8urfGL._SL1500_.98ee5105.jpg";